import { useMemo, ReactNode } from "react";
import { Tabs } from "shared/components/Tabs";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";
import { EnrollmentCase } from "views/rent-reporting-id/types";
import { getTabDisplayName } from "../utils";

interface EnrollmentTabsProps {
  enrollmentCases: EnrollmentCase[];
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

export const EnrollmentTabs = ({
  enrollmentCases,
  activeTab,
  setActiveTab
}: EnrollmentTabsProps) => {
  const tabIds = useMemo(
    () => enrollmentCases.map((c) => String(c.id)),
    [enrollmentCases]
  );

  const tabsDisplayMap = useMemo(() => {
    const map: Record<string, ReactNode> = {};
    for (const c of enrollmentCases) {
      const displayName = getTabDisplayName(c);
      const tabId = String(c.id);

      map[tabId] = (
        <Tooltip key={tabId}>
          <TooltipTrigger asChild>
            <div className="max-w-[204px] truncate">{displayName}</div>
          </TooltipTrigger>
          <TooltipContent className="max-w-[300px] rounded-lg border bg-alpha-800 p-4 text-sm text-content-1000-inverted z-[50] shadow-md">
            {displayName}
          </TooltipContent>
        </Tooltip>
      );
    }
    return map;
  }, [enrollmentCases]);

  if (enrollmentCases.length < 1) return null;

  return (
    <div className="mb-4">
      <Tabs
        tabs={tabIds}
        displayMap={tabsDisplayMap}
        variant="underline"
        selected={activeTab}
        setActiveTab={(tab) => setActiveTab(String(tab))}
      />
    </div>
  );
};
